export default "__VITE_ASSET__BLJG1ZGM__"